import { render } from "./BackgroundModal.vue?vue&type=template&id=2f6c5ef6&scoped=true"
import script from "./BackgroundModal.vue?vue&type=script&lang=js"
export * from "./BackgroundModal.vue?vue&type=script&lang=js"

import "./BackgroundModal.vue?vue&type=style&index=0&id=2f6c5ef6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6c5ef6"]])

export default __exports__